import axios from "axios";
import { apiEndpoint } from "../../../routes/api_endpoints";
import { API_KEY } from "../../../utilities/apiKey";

const getTickets = (MobileNumber) =>
  new Promise((resolve, reject) => {
    axios
      .post(
        apiEndpoint,
        {
          RequestID: "MYTICKETS",
          SessionID: "HBhGpLw0efgwbDqILlYSCC9WT5hoo=4oCh",
          Country: "KENYA",
          City: "NAIROBI",
          UserID: "Pesapal",
          Key: "2344",
          TrxReference: "123487",
          IMEI: "231766434532535",
          MobileNumber,
        },
        {
          headers: {
            "X-API-KEY": API_KEY,
          },
        }
      )
      .then((response) => {
        if (response.data) {
          resolve(response.data);
        } else resolve([]);
      })
      .catch((error) => reject(error));
  });

export default getTickets;
